import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CustomRadioButtonGroup from './CustomRadioButtonGroup';
import { Field } from 'react-final-form';
import { TextFieldComponent } from './CustomFormElement';
import validators from '../utils/validators';
import { portalCfg } from '../config';

const visaImg = portalCfg.publicPath + "/images/visa.png";
const cardImg = portalCfg.publicPath + "/images/mastercard.png";
const voucherImg = portalCfg.publicPath + "/images/voucher.png";
const mobicredImg = portalCfg.publicPath + "/images/mobicred.jpg";

const useStyles = makeStyles((theme) => ({
    payments: {
        // background: theme.palette.common.white,
        padding: theme.spacing(2, 0),
    },
    item_payment: {
        padding: theme.spacing(2, 0),
        alignItems: 'center',
    },
    icon_payment: {
        // width: theme.spacing(5),
        height: theme.spacing(5),
        padding: theme.spacing(0, 1)
    }
}));

export default function PaymentMethod(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const {payment_selected, onChangePayment} = props;

    const payments = [
        {
            label: <Grid item xs={12} container direction='row' className={classes.item_payment}>
                <Typography variant='body2'>{t('payment_credit_card')}</Typography>
                <img src={visaImg} alt={t('payment_credit_card')} className={classes.icon_payment}></img>
                <img src={cardImg} alt={t('payment_credit_card')} className={classes.icon_payment}></img>
            </Grid>,
            value: 'CARD'
        },
        {
            label: <Grid item xs={12} container direction='row' className={classes.item_payment}>
                <Typography variant='body2'>{t('payment_voucher')}</Typography>
                <img src={voucherImg} alt={t('payment_voucher')} className={classes.icon_payment}></img>
            </Grid>,
            value: 'VOURCHER',
            child: <Grid item xs={12} container direction='row'>
                <Grid xs={12} item>
                    <Field
                        fullWidth
                        name="voucher_pin"
                        component={TextFieldComponent}
                        placeholder={t('enter_voucher') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>,
        },
        {
            label: <Grid item xs={12} container direction='row' className={classes.item_payment}>
                <Typography variant='body2'>{t('payment_mobicred')}</Typography>
                <img src={mobicredImg} alt={t('payment_mobicred')} className={classes.icon_payment}></img>
            </Grid>,
            value: 'ORTHER'
        },
    ];

    return (
        <Grid item xs={12} justify="center" alignItems="center">
            <Grid item xs={12} className={classes.payments}>
                <CustomRadioButtonGroup 
                    items={payments}
                    selected={payment_selected ? payment_selected : null}
                    onChange={onChangePayment}
                />
            </Grid>
        </Grid>
    );
}